export default __webpack_public_path__ + "976add70551d6fbd90384ac0febc6cba.png";